import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { NavbarComponent } from '../topNavBar/navbar.component';
import { FooterComponent } from '../shared/footer/footer.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatDividerModule,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  values = [
    {
      icon: 'volunteer_activism',
      title: 'Built for Frontline Workers',
      description: 'Designed around the realities of under-resourced facilities — simple, fast, and dependable when it matters most.'
    },
    {
      icon: 'psychology',
      title: 'AI-Powered, Human-Led',
      description: 'Decision support that augments clinical judgement, never replaces it. The health worker stays in control.'
    },
    {
      icon: 'security',
      title: 'FHIR Compliance',
      description: 'Built on FHIR R4 standards for safe, interoperable data exchange with the wider health system.'
    },
    {
      icon: 'cloud',
      title: 'Works Anywhere',
      description: 'Cloud-based and built with low-connectivity settings in mind, so care doesn\u2019t stop when the signal does.'
    }
  ];

  team = [
    {
      photo: '/assets/images/drsadiq.jpg',
      name: 'Dr. Muhammad Saddiq',
      role: 'Founder',
      bio: 'Leading the vision behind e-Likita\u2019s mission to bridge healthcare delivery gaps across underserved communities.'
    }
  ];

  partners = [
    {
      logo: 'assets/images/afcicon.png',
      name: 'Africa Health Care Development Trust',
      url: 'https://ahdt.co.uk/',
      description: 'A network of expert healthcare specialists offering medical guidance and mentorship.'
    },
    {
      logo: 'assets/images/dhtflogo.png',
      name: 'Dechi Health Trust Fund',
      url: 'https://dechihtf.org/',
      description: 'The pioneer behind this digital health initiative, dedicated to ensuring equitable access to quality healthcare and affordability in rural Nigeria.',
      featured: true
    },
    {
      logo: 'assets/images/dalitechicon.png',
      name: 'DAALITech',
      url: 'https://www.daalitech.com/',
      description: 'A Data and AI startup spearheading the technological development of the project.'
    }
  ];
}